export const accountPrefix = 'account'
export const wisdomsitePrefix = 'wisdomsite'
